import _ from 'lodash';

export default class PersistenceService {

  static setItem(key, value) {

    if(!_.isString(value)){
      value = `${value}`;
    }

    return new Promise((resolve, reject) => {
      resolve(localStorage.setItem(key, value));
    });
  }

  static getItem(key) {

    return new Promise((resolve, reject) => {
      resolve(localStorage.getItem(key));
    });
  }

  static getItems(keys) {
    let promises = [];
    _.map(keys, key => {
      promises.push(PersistenceService.getItem(key));
    })
    return Promise.all(promises);
  }

}



// WEBPACK FOOTER //
// ./src/service/PersistenceService.js